import React from 'react';
import { connect } from 'react-redux';
import Spinner from '@atlaskit/spinner';
import MenuListEvents from './MenuListEvents';
import MenuWorkspaceEvent from './MenuWorkspaceEvent';
import HeaderItemProfile from '../PageHeader/HeaderItemProfile';
var selfStyles = require('./styles.scss');
var PageMenu = function (props) {
    if (!props.router.location || !props.store.user) {
        return (React.createElement("div", { className: selfStyles.menuLoading }));
    }
    if (!props.store.events) {
        return (React.createElement("div", { className: selfStyles.menuLoading },
            React.createElement(Spinner, null)));
    }
    var pathname = props.router.location.pathname;
    return (React.createElement("div", { className: selfStyles.menuWrapper },
        pathname.indexOf('/event') === 0
            ? React.createElement(MenuWorkspaceEvent, { events: props.store.events })
            : React.createElement(MenuListEvents, { events: props.store.events }),
        React.createElement(HeaderItemProfile, null)));
};
var mapStateToProps = function (state) { return ({
    store: {
        user: state.workspaceMain.user && state.workspaceMain.user.data[0],
        events: state.workspaceMain.events && state.workspaceMain.events.data,
    },
    router: state.router,
}); };
export default connect(mapStateToProps)(PageMenu);



//////////////////
// WEBPACK FOOTER
// ./src/pages/templates/components/PageMenu/index.tsx
// module id = 803
// module chunks = 0